import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/authFetch';

const money = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const number = value => value == null || value === '' ? null : Number(String(value).replace(',', '.'));

export default function StockDocumentTotals({ lines, docId, recType, closed }) {
  const [stock, setStock] = useState(null);
  useEffect(() => {
    let active = true;
    setStock(null);
    if (docId && recType === 3) {
      authFetch(`/bon-consum/${docId}/stocout`).then(data => {
        if (active) setStock({ docId, rows: Array.isArray(data) ? data : data?.items || data?.linii_out || [] });
      }).catch(() => { if (active) setStock(null); });
    }
    return () => { active = false; };
  }, [docId, recType, closed]);

  const rows = stock && stock.docId === docId ? stock.rows : [];
  const valid = lines.filter(line => line.bxpart_id || line.bxstocin_id);
  let total = 0;
  let complete = true;
  if (closed && recType === 3 && valid.length) {
    complete = rows.length > 0;
    rows.forEach(row => {
      const amount = number(row.valoare) ?? (number(row.bxqtyscazut) * number(row.pret_stocin));
      if (!Number.isFinite(amount) || (row.valoare == null && row.pret_stocin == null)) complete = false;
      else total += amount;
    });
  } else {
    valid.forEach(line => {
      const qty = number(line.qty);
      let price = number(line.stockPrice);
      if (price == null) {
        const matching = rows.filter(row => Number(row.bxpart_id) === Number(line.bxpart_id));
        const quantity = matching.reduce((sum, row) => sum + Number(row.bxqtyscazut || 0), 0);
        if (quantity && matching.every(row => row.valoare != null || row.pret_stocin != null)) {
          price = matching.reduce((sum, row) => sum + (number(row.valoare) ?? Number(row.bxqtyscazut) * number(row.pret_stocin)), 0) / quantity;
        }
      }
      if (qty === 0) return;
      if (qty == null || price == null || !Number.isFinite(qty * price)) complete = false;
      else total += qty * price;
    });
  }
  return <section aria-label="Total bon" aria-live="polite" className="border rounded bg-body-tertiary p-3 mb-3 text-end">
    <div className="small text-muted">{closed ? 'Total valoare' : 'Total valoare estimată'}</div>
    <div className="fs-5 fw-bold" data-testid="stock-document-total">{complete ? money.format(total) : '—'} <span className="small">RON</span></div>
    {!complete && <div className="small text-muted">Valoarea nu este disponibilă pentru toate liniile.</div>}
  </section>;
}
